module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0018572_banner.4c1f0e8a.png";